import { Col, Container, Row } from 'react-bootstrap'
import { Blog } from 'src/@shared/types/cms/blog'
import Image from 'next/image'
import shortMonthDate from 'src/@shared/functions/dateFormat'
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share'
import FacebookIcon from '@assets/icons/share-icon-facebook.svg'
import LinkedinIcon from '@assets/icons/share-icon-linkedin.svg'
import TwitterIcon from '@assets/icons/share-icon-twitter.svg'
import { getCMSImage } from 'src/@shared/functions/format'

import Icon from '@atk/components/icon'

import FramerMotion from '@atk/hooks/framerMotion'

import styles from './BlogDetailPost.module.scss'

export type blogDetailPostProps = {
    post: Blog
}

const baseUrl = process.env.NEXT_PUBLIC_HOST as string

export default function BlogDetailPost({ post }: blogDetailPostProps) {
    const formattedDate = shortMonthDate(post.timePublished)
    const currentUrl = `${baseUrl.substring(0, baseUrl.length - 1)}/blog/${post.meta.slug}`
    return (
        <section className="blogDetailPost pt-0">
            <div className={styles.containerBg}>
                <Container>
                    <Row>
                        <Col lg={{ span: 8, offset: 2 }}>
                            <div className={styles.halfTitleContainer}>
                                {post.categoryName && (
                                    <p className={` ${styles.halfTitleCategory}`}>{post.categoryName ?? ''}</p>
                                )}
                                <p>{formattedDate}</p>
                            </div>
                            <h2 className="mb-5">{post.title}</h2>
                            <h4 className="pb-2" dangerouslySetInnerHTML={{ __html: post.preview ?? '' }}></h4>
                            {post.author && (
                                <div className="d-flex gap-4 mb-5 align-items-center">
                                    <Image
                                        className={styles.authorImg}
                                        src={getCMSImage(post.author?.imageUrl)}
                                        alt={post.author?.name}
                                        height={80}
                                        width={80}
                                    />
                                    <div className={`d-flex flex-column ${styles.authorInfo}`}>
                                        <p className={`mb-2 ${styles.authorName}`}>{post.author.name ?? ''}</p>
                                        <p className="mb-0">{post.author.title}</p>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container>
                <Row className={`mb-5 pt-3 align-items-center ${styles.imgHeader}`}>
                    <Col sm={1} lg={2} className={styles.socialSharingContainer}>
                        <FacebookShareButton url={currentUrl} quote={post.title}>
                            <Icon source={FacebookIcon.src}></Icon>
                        </FacebookShareButton>
                        <TwitterShareButton url={currentUrl} title={post.title}>
                            <Icon source={TwitterIcon.src}></Icon>
                        </TwitterShareButton>
                        <LinkedinShareButton
                            url={currentUrl}
                            title={post.title}
                            summary={post.meta.description ?? ''}
                            source="Casper Labs"
                        >
                            <Icon source={LinkedinIcon.src}></Icon>
                        </LinkedinShareButton>
                    </Col>
                    <Col sm={11} lg={10} className={styles.imgContainer}>
                        <Image
                            src={getCMSImage(post.headerUrl ?? post.thumbnailUrl)}
                            alt={post.title}
                            className="position-relative"
                            fill
                        />
                    </Col>
                </Row>
            </Container>
            <FramerMotion>
                <Container>
                    <Row className={`mt-5 align-items-center ${styles.postBody}`}>
                        <Col sm={1} lg={2}>
                            <div></div>
                        </Col>
                        <Col sm={11} lg={8} className={styles.mobilePaddingX}>
                            <div className="body" dangerouslySetInnerHTML={{ __html: post.body ?? '' }}></div>
                            <hr className="lineBodyEnd"></hr>
                        </Col>
                    </Row>
                </Container>
            </FramerMotion>
        </section>
    )
}
